import { tw } from "@careinfo/tailwind";

export default function ({ info, isLoading, title }) {
  return (
    <div className={tw`space-y-1`}>
      <p className={tw`md:text-md font-semibold`}>{title}</p>
      <div className={tw`text-sm`}>
        <p className={tw`capitalize`}>
          Name:
          {isLoading ? <Loader /> : info?.full_name}
        </p>
        <p className={tw`flex flex-row`}>
          Phone:
          <p className={tw`text-sm text-gray-500 block`}>
            {isLoading ? <Loader /> : info?.primary_contact}
          </p>
        </p>
        <p>
          Location:
          {isLoading ? <Loader /> : info?.address}
        </p>
      </div>
    </div>
  );
}

export function Loader() {
  return (
    <span
      className={tw`w-[10ch] animate-pulse inline-block h-[1ch] rounded-md bg-gray-500`}
    ></span>
  );
}
